"use strict";
var keyboard_1 = require('./keyboard');
exports.Keyboard = keyboard_1.Keyboard;
var octave_1 = require('./octave');
exports.Octave = octave_1.Octave;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEseUJBQXlCLFlBQVksQ0FBQyxDQUFBO0FBRzdCLGdCQUFRO0FBRmpCLHVCQUF1QixVQUFVLENBQUMsQ0FBQTtBQUVmLGNBQU07QUFBRyJ9


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/sequencer/keyboard/index.ts
 ** module id = 960
 ** module chunks = 1
 **/